import type React from 'react';

/**
 * An enlarged, blurred and darkened copy of the petition image, used to fill the
 * letterboxing around the 9:16 embed. `scale-125` pushes the blur's soft edges out of
 * frame so the container corners stay fully covered.
 */
export const BlurredBackdrop: React.FC<Props> = ({ coverUrl }) => {
	if (!coverUrl) return null;

	return (
		<div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
			<img alt="" src={coverUrl} className="h-full w-full scale-125 object-cover opacity-35 blur-[10px]" />
		</div>
	);
};

type Props = {
	coverUrl: string | undefined;
};
